/** Formatter condivisi per date, durate, importi. */

export function formatDataOra(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  return d.toLocaleString('it-IT', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  })
}

export function formatData(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  return d.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export function formatDurata(secondi: number | null | undefined): string {
  if (secondi == null) return '—'
  const m = Math.floor(secondi / 60)
  const s = secondi % 60
  return `${m}m ${String(s).padStart(2, '0')}s`
}

export function formatEuro(n: number | null | undefined): string {
  if (n == null) return '€ 0'
  return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(n)
}

export function etichettaDifficolta(d: number): string {
  if (d === 1) return 'Facile'
  if (d === 2) return 'Medio'
  return 'Difficile'
}

export function varianteDifficolta(d: number): 'success' | 'warning' | 'danger' {
  if (d === 1) return 'success'
  if (d === 2) return 'warning'
  return 'danger'
}

export function etichettaPiano(p: string): string {
  if (p === 'free') return 'Free'
  if (p === 'pro') return 'Pro'
  if (p === 'team') return 'Team'
  if (p === 'enterprise') return 'Enterprise'
  return p
}

export function variantePiano(p: string): 'default' | 'info' | 'accent' | 'success' {
  if (p === 'pro') return 'info'
  if (p === 'team') return 'accent'
  if (p === 'enterprise') return 'success'
  return 'default'
}
